import Page, { PageData } from "../Page";
import { Coordinate, CoordinateData } from "./Coordinate";
import { Section, SectionData, SectionTypes } from "./Section";

export { PageSection, PageSectionData, convertAbsoluteToPercentage };

type PageSectionData = {
  topLeft: CoordinateData;
  bottomRight: CoordinateData;
} & SectionData;

/**
 * Return a new PageSectionData object with percentage values based off Page
 * @param pageSection
 * @param page
 * @returns
 */
function convertAbsoluteToPercentage(
  pageSection: PageSectionData,
  page: Page | PageData,
): PageSectionData {
  const newPageSection: any = {};
  newPageSection.topLeft = Coordinate.toPercentage(
    pageSection.topLeft,
    page.width,
    page.height,
  );
  newPageSection.bottomRight = Coordinate.toPercentage(
    pageSection.bottomRight,
    page.width,
    page.height,
  );
  return newPageSection;
}

class PageSection implements Section, PageSectionData {
  discriminator: SectionTypes = "PAGE";
  topLeft: Coordinate;
  bottomRight: Coordinate;

  constructor(data: PageSectionData) {
    this.topLeft = new Coordinate(data.topLeft);
    this.bottomRight = new Coordinate(data.bottomRight);
  }
  isConfigured(): boolean {
    return (
      this.topLeft.x !== this.topLeft.y &&
      this.bottomRight.x !== this.bottomRight.y
    );
  }
  clear(): void {
    this.topLeft.setX(0);
    this.topLeft.setY(0);
    this.bottomRight.setX(0);
    this.bottomRight.setY(0);
  }
  toSectionData(): PageSectionData {
    return {
      topLeft: this.topLeft.toCoordinateData(),
      bottomRight: this.bottomRight.toCoordinateData(),
      discriminator: this.discriminator,
    };
  }
  getSectionType(): SectionTypes {
    return this.discriminator;
  }
  getSectionId(): string {
    return `${this.discriminator}-[${this.topLeft.getCoordinateId()}]-[${this.bottomRight.getCoordinateId()}]`;
  }

  static createTest(rest: Partial<PageSectionData> = {}): PageSection {
    const data: PageSectionData = {
      topLeft: {
        x: 0,
        y: 0,
      },
      bottomRight: {
        x: 0,
        y: 0,
      },
      discriminator: "PAGE",
    };

    return new PageSection({
      ...data,
      ...rest,
    });
  }
}
